import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import configuration from './modules/configuration';

Vue.use(Vuex);
/* eslint-disable */
export default new Vuex.Store({
  modules: {
    auth,
    configuration,
  },
  state: {},
  mutations: {},
});



// WEBPACK FOOTER //
// ./src/store/index.js